<template>
    <v-card
      :class="breakPointChange"
      class="ml-auto pa-5 mt-3 body-2 green lighten-5"
      elevation="0"
    >
      <div class="d-flex">
        <div class="mr-3 mh-10 text-center">
          <PixIcon
            v-if="isAPixPayment"
            opacity="0.3"
            height="20"
            width="20"
          />

          <v-icon color="grey">
            {{ methods[paymentMethod] }}
          </v-icon>
        </div>

        <div>
          <h4 v-if="hasFCI && !payWithFci" class="subtitle-2">
            {{ $t('quote.hint.paymentMethodAndFCIWithoutAmount', { method }) }}
          </h4>
          <h4 v-else class="subtitle-2">
            {{ $t('quote.hint.paymentMethodWithoutAmount', { method }) }}
          </h4>

          <div v-if="!isClient && !isTenant">
            <!-- CARD -->
            <p v-if="isACreditCardPayment" class="mb-0 caption">
              <span v-if="summaryInstallments >= 2">
                {{ $t('quote.hint.totalInstallments', { summaryInstallmentValue, summaryInstallments, chargedValue }) }}
              </span>
              <span v-else>
                {{ $t('quote.hint.totalInstallment', { summaryInstallmentValue, summaryInstallments }) }}
              </span>
            </p>
            <!-- CARD -->

            <!-- PIX -->
            <p v-if="isAPixPayment" class="mb-0 caption">
              {{ $t('quote.hint.totalPixPayment', { summaryChargedValue }) }}
            </p>
            <!-- PIX -->

            <!-- FCI -->
            <p v-if="payWithFci" class="mb-0 caption">
              {{ $t('quote.hint.totalFCI', { summaryFCI }) }}
            </p>
            <!-- FCI -->

            <!-- PARTIAL FCI -->
            <p v-if="!payWithFci && hasFCI" class="mb-0 caption">
              {{ $t('quote.hint.totalFCI', { summaryFCI }) }}
            </p>
            <!-- PARTIAL FCI -->

            <!-- TOTAL -->
            <p class="mb-0 font-weight-bold caption">
              {{ $t('quote.hint.totalPayment', { summaryTotal }) }}
            </p>
            <!-- TOTAL -->
          </div>
        </div>
      </div>
    </v-card>
  </template>

  <script>
  import { mapGetters } from 'vuex'
  import PixIcon from '@/components/icons/Pix'
  import { catalogMonetary } from '@/util/catalog'

  export default {
    name: 'QuotePaymentMethods',

    components: {
      PixIcon,
    },

    props: {
      paymentMethod: {
        type: String,
      },

      quoteItems: {
        type: Object,
      },

      payWithFci: {
        type: Boolean,
      },

      isEviction: {
        type: Boolean,
      },
    },

    computed: {
      ...mapGetters(['user']),

      breakPointChange() {
        return !this.$vuetify.breakpoint.mobile && 'mw-400'
      },

      method() {
        return this.$t(`payment.type.${this.paymentMethod}`)
      },

      isAPixPayment() {
        return this.paymentMethod === 'ASAAS_PIX'
      },

      isACreditCardPayment() {
        return this.paymentMethod === 'ASAAS_CREDIT_CARD'
      },

      amount() {
        if (this.payWithFci)
          return this.formatMoney(
            this.quoteItems.net_fci
              ? this.quoteItems.net_fci
              : this.quoteItems.subtotal
          )

        if (!this.payWithFci && !this.isEviction)
          return this.formatMoney(this.quoteItems?.charge?.value)

        if (this.isEviction)
          return this.formatMoney(this.quoteItems?.charge?.value)
      },

      discount() {
        return this.formatMoney(this.quoteItems?.cash_discount)
      },

      isDiscountMoreThanZero() {
        return this.quoteItems?.cash_discount > 0
      },

      installments() {
        return this.quoteItems?.charge?.installments?.length
      },

      isClient() {
        return this.userType === 'ROLE_REAL_ESTATE'
      },

      isTenant() {
        return this.userType === null || this.userType === undefined
      },

      hasSummary() {
        return this.quoteItems?.charge_summary !== null
      },

      summary() {
        if (!this.hasSummary) return
        return this.quoteItems?.charge_summary
      },

      summaryTotal() {
        if (!this.hasSummary) return '---'
        return this.formatMoney(this.summary?.total)
      },

      summaryChargedValue() {
        if (!this.hasSummary) return '---'
        return this.formatMoney(this.summary?.charged_value)
      },

      hasFCI() {
        if (!this.hasSummary) return
        return this.summary?.fci_net_value > 0
      },

      summaryFCI() {
        if (!this.hasSummary) return
        return this.formatMoney(this.summary?.fci_net_value)
      },

      summaryInstallments() {
        if (!this.hasSummary) return
        return this.summary?.installment_quantity
      },

      summaryInstallmentValue() {
        if (!this.hasSummary) return
        return this.formatMoney(this.summary?.installment_value)
      },

      chargedValue() {
        if (!this.hasSummary) return
        return this.formatMoney(this.summary?.charged_value)
      },
    },

    methods: {
      checkUserType() {
        Promise
          .resolve(this.user)
          .then(({ type }) => this.userType = type)
      }
    },

    data() {
      return {
        formatMoney: catalogMonetary,

        methods: {
          VALUELESS: 'mdi-bank',
          ASAAS_BOLETO: 'mdi-barcode',
          BALANCE: 'mdi-wallet-outline',
          ASAAS_CREDIT_CARD: 'mdi-credit-card-outline',
        },

        userType: null,
      }
    },

    mounted() {
      this.checkUserType()
    },
  }
  </script>
